import axios from 'axios'
import {API_KEY, cnrAddress, defaultScanApi, greenHouseAddress} from "../config";

const instance = axios.create({ baseURL: defaultScanApi })
// https://api-testnet.bscscan.com/api?module=logs&action=getLogs
// &fromBlock=4993830
// &toBlock=4993832
// &address=0xe561479bebee0e606c19bb1973fc4761613e3c42
// &topic0=0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef
// &apikey=YourApiKeyToken
export const api = {
    // https://api.etherscan.io/api?module=proxy&action=eth_blockNumber&apikey=YourApiKeyToken
    getLatestBlock: () => instance.get('/api', { params: {
        module: 'proxy',
        action: 'eth_blockNumber',
        apiKey: API_KEY
    }}),
    // getTsx: (address, fromBlock, toBlock) => instance.get('/api', { params: {
    //         module: 'logs',
    //         action: 'getLogs',
    //         fromBlock,
    //         toBlock,
    //         // page: 1,
    //         // offset: 1000,
    //         address,
    //         apiKey: API_KEY // TODO check it on bsscan?
    //     }}),
    getErc20TsxByAddr: (uAddress) => instance.get('/api', { params: {
            module: 'account',
            action: 'tokentx',
            contractaddress: cnrAddress,
            address: uAddress,
            // &page=1
            // &offset=100
            sort: 'desc', // asc
            apikey: API_KEY
    }}),
    getAccountFirstBlockTs: (address) => instance.get('/api', { params: {
            module: 'account',
            action: 'txList',
            address: address,
            startblock: 0,
            page: 1,
            offset: 10,
            sort: 'asc',
            apiKey: API_KEY
        }}),
    getLatestTransactions: (fromBlock, toBlock) => instance.get('/api', { params: {
            module: 'account',
            action: 'txList',
            address: greenHouseAddress,
            startblock: fromBlock,
            endblock: toBlock,
            page: 1,
            offset: 1000,
            sort: 'asc',
            apiKey: API_KEY
        }}),
}

// Get a list of 'ERC20 - Token Transfer Events' by Address
// https://api.etherscan.io/api
//    ?module=account
//    &action=tokentx
//    &contractaddress=0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2
//    &address=0x4e83362442b8d1bec281594cea3050c8eb01311c
//    &page=1
//    &offset=100
//    &sort=asc
//    &apikey=YourApiKeyToken